import { ApiProvider } from "api/api"
import { NotificationProvider } from "components/Notification/Notification"
import { AuthProvider } from "modules/auth/Auth"
import { FlagsProvider } from "modules/flags/flags"
import { initSentry } from "modules/monitoring/monitoring"
import { PageRouter } from "pages/router"
import { StylesProvider } from "styles/StylesProvider"

initSentry()

export function App() {
	return (
		<AuthProvider>
			<ApiProvider>
				<FlagsProvider>
					<StylesProvider>
						<NotificationProvider>
							<PageRouter />
						</NotificationProvider>
					</StylesProvider>
				</FlagsProvider>
			</ApiProvider>
		</AuthProvider>
	)
}
